import dns from "dns";
import initializeAxios from "@src/initializers/axios";
import { extractApiErrorMessage, reportToHoneybadger } from "@utils/common";
import { sendHeartBeatSignal } from "@utils/onBegin";
import consoleLogFormatted from "consoleLogFormatted";
export const initialize = (self, options) => {
    dns.setDefaultResultOrder("ipv4first");
    const resolvedOptions = {
        projectKey: options.projectKey || process.env.NEETO_PROJECT_KEY || "",
        baseURL: options.baseURL || process.env.NEETO_PLAYDASH_API_BASE_URL || "",
        apiKey: options.apiKey || process.env.NEETO_API_KEY || "",
        ciBuildId: options.ciBuildId || process.env.NEETO_CI_BUILD_ID || "",
        tags: options.tags,
        title: options.title,
        commitId: options.commitId,
        author: options.author,
        branch: options.branch,
    };
    initializeAxios(resolvedOptions);
    process.stdout.on("error", (error) => {
        var _a;
        if (!["EPIPE", "EIO"].includes((_a = error.code) !== null && _a !== void 0 ? _a : "")) {
            process.stderr.write(`Unexpected stdout error: ${error.message}\n`);
        }
    });
    process.on("unhandledRejection", async (error) => {
        var _a;
        try {
            await reportToHoneybadger({
                context: {},
                error,
                title: "unhandledRejection",
            });
            await sendHeartBeatSignal(self.ciBuildId);
            consoleLogFormatted.error((_a = extractApiErrorMessage(error)) !== null && _a !== void 0 ? _a : JSON.stringify(error));
        }
        catch (error) {
            consoleLogFormatted.error("Honeybadger failed :(");
        }
    });
};
//# sourceMappingURL=initialize.js.map